export const version = {
  computed: {
    appName: function() {
      const applname = this.serverVersion.applname.toLowerCase();
      return applname.charAt(0).toUpperCase() + applname.slice(1);
    },
    webVersion: function() {
      const versionPackage = APPVERSION.split(".");
      return `${versionPackage[1]}.${versionPackage[2]}`;
    }
  }
};
